/**
 * Labstep
 *
 * @module core/DataGrid/CellEditor/File
 * @desc CellEditor File
 */

import FileActionCreate from 'labstep-web/components/File/Action/Create';
import type { Entity } from 'labstep-web/models/entity.model';
import React from 'react';
import { setValue, stopEditingAndFocus } from '../../utils';
import type { ICellEditorFileProps } from './types';

export const DataGridCellEditorFile: React.FC<
  ICellEditorFileProps<Entity>
> = React.memo((params) => {
  const valueUpdateFile = (fileId: number): void => {
    setValue(
      'file_id',
      fileId,
      {
        entityName: params.props.entity.entityName,
        id: params.props.entity.id,
        createProps: params.props.createProps,
      },
      undefined,
      {
        optimistic: false, // need to wait for file upload
        onSuccess: () => {
          if (!params.node) {
            return;
          }
          params.api.refreshCells({
            rowNodes: [params.node],
            columns: [params.column],
            force: true,
          });
        },
      },
    );
    stopEditingAndFocus(params);
  };

  return (
    <FileActionCreate
      onFolderWatcherSelect={({ file }): void =>
        valueUpdateFile(file.id)
      }
      options={{
        onSuccess: ({ response }: any) => {
          const fileId = Array.isArray(response.result)
            ? response.result[0]
            : response.result;
          valueUpdateFile(fileId);
        },
      }}
      modalProps={{
        onClose: (): void => stopEditingAndFocus(params),
        open: true,
        viewComponent: null,
      }}
    />
  );
});
